import { atom } from "jotai";

const createdProjectsAtom = atom<any[]>([]);
createdProjectsAtom.debugLabel = "Created Projects";

export { createdProjectsAtom };
